import { useMemo } from "react";

const usePermission = () => {
  const permissions = useMemo(() => {
    try {
      const stored = localStorage.getItem("permissions");
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error("Invalid permissions in localStorage", error);
      return [];
    }
  }, []);

  return permissions;
};

export default usePermission;
